import React from "react";
import { Link } from "react-router-dom";

const BreadcrumbHeader = ({ location, title, locationId }) => {
  return (
    <div className="filterouter align-items-center">
      <div className="breadcrumbinner">
        <div className="w-100">
          <ol className="breadcrumb">
            <li><Link to="/">Home</Link></li>
            {/* <li><Link to={`/stays?location=${location}`}>Homestays in {location}</Link></li> */}
            <li>
              <Link
                to="/stays"
                state={{
                  destination_name: location,      // same key BannerSearch expects
                  destination_id: locationId,               // optional (can be filled later)
                  checkin_date: "",                 // optional
                  checkout_date: "",                // optional
                  adults: "1",
                  kids: ""
                }}
              >
                Homestays in {location}
              </Link>
            </li>

            <li className="active">{title}</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default BreadcrumbHeader;
